const categorysListUtils = [

  {
    key: "PEITO",
    name: "PEITO",

  },
  {
    key: "COSTAS",
    name: "COSTAS",

  },
  {
    key: "BICEPS",
    name: "BÍCEPS",

  },
  {
    key: "ANTE_BRACO",
    name: "ANTE-BRAÇO",

  },
  {
    key: "TRICEPS",
    name: "TRÍCEPS",

  },
  {
    key: "MEMBROS_INFERIORES",
    name: "MEMBROS INFERIORES",

  },
  {
    key: "OMBRO",
    name: "OMBRO",

  },
  {
    key: "TRAPEZIO",
    name: "TRAPÉZIO",

  },
  {
    key: "ABDOMINAL",
    name: "ABDOMINAL",

  },
  {
    key: "AEROBIO",
    name: "AERÓBIO",

  },
  {
    key: "FUNCIONAL",
    name: "FUNCIONAL",

  },
  {
    key: "ALONGAMENTOS",
    name: "ALONGAMENTOS",

  },


]

export { categorysListUtils };


// WEBPACK FOOTER //
// src/utils/categorys-exercises.js